import React from "react";
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import GenericCard from "../GenericCard";
import MenuIcon from "./MenuIcon";
import { useRouteMatch } from "react-router-dom";
import { activateMobileMenu } from "../../utils/helpers";

const MenuButton = ({ isSettings }) => {
  let routeName = useRouteMatch().path.slice(1);
  if (routeName.includes("/")) {
    routeName = routeName.split("/").pop(); // always gets the last string in the route
  }
  let pageName = routeName.slice(0, 1).toUpperCase() + routeName.slice(1);

  return (
    <button onClick={activateMobileMenu} className={menu}>
      <GenericCard style="menuCard">
        <p>
          {pageName.length > 0 ? pageName : isSettings ? "Settings" : "Home"}
        </p>
        <MenuIcon />
      </GenericCard>
    </button>
  );
};

export default MenuButton;

const menu = css`
  background-color: white;
  border: none;
  overflow: visible;
  padding: 10px 6px;

  .menuCard {
    width: auto;
    padding: 4px ${boxStyles.standardPadding};
    font-size: ${textSizes.normal};
    border-radius: 40px;
    color: ${colors.placeholderText};
    overflow: visible;
  }
`;
